import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'
import { Button, Icon, Typography } from 'shared/ui'
import { useEntitiesContext } from 'entities/EntitiesExport'
import {
  ProviderSuspendedPage,
  useSuspendedPageContext,
} from 'pages/suspended/context/suspendedContext'
import { SuspendedPageStore } from 'pages/suspended/store/suspendedPageStore'
import styles from './styles.module.scss'

const SuspendedPageContent = observer(() => {
  const store = useSuspendedPageContext()

  return (
    <div className={styles.wrap}>
      <div className={styles.logo}>
        <Icon icon={'salesmessageFull'} fontSize={146} ariaLabel={'SalesmessageLogo'} />
      </div>

      <div className={styles.content}>
        <div className={styles.iconCircle}>
          <div className={styles.iconBox}>
            <Icon
              icon={'info'}
              fontSize={20}
              color={'var(--content-primary-primary-inverted)'}
              ariaLabel={'SuspendedInfo'}
            />
          </div>
        </div>

        <Typography className={styles.title} variant={'heading-lg'} ariaLabel={'SuspendedTitle'}>
          {store.title}
        </Typography>

        <Typography
          className={styles.description}
          variant={'body-lg-regular'}
          color={'var(--content-primary-tertiary)'}
          ariaLabel={'SuspendedDescription'}
        >
          {store.description}
        </Typography>

        <div className={styles.actionsWrap}>
          {store.isRestartVisible && (
            <Button
              text={'Restart subscription'}
              onClick={store.restartSubscription}
              aria-label={'RestartSubscription'}
              className={styles.action}
            />
          )}
          <Button
            typeBtn={'stroke'}
            text={'Logout'}
            onClick={store.logout}
            aria-label={'Logout'}
            className={styles.action}
          />
        </div>
      </div>
    </div>
  )
})

export const SuspendedPage = () => {
  const entities = useEntitiesContext()
  const store = useMemo(() => new SuspendedPageStore(entities), [entities])

  return (
    <ProviderSuspendedPage value={store}>
      <SuspendedPageContent />
    </ProviderSuspendedPage>
  )
}
